export const GET_SOURCE_ENTITIES = "GET_SOURCE_ENTITIES";
export const GET_SOURCE_ENTITIES_SUCCESS = "GET_SOURCE_ENTITIES_SUCCESS";
export const GET_SOURCE_ENTITIES_FAILURE = "GET_SOURCE_ENTITIES_FAILURE";